import { Payslip, PayslipsResponse } from "@core/app/types/v2/payslips"
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

export const payslipsApi = createApi({
    reducerPath: 'payslipsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.ENV === 'local' ? `${process.env.API_URL}/api` : `${window.location.origin}/api`,
        prepareHeaders: (headers) => {
            headers.set('Response-V2', '1')
            const token = document.getElementsByName('csrf-token')[0]?.getAttribute('content')
            if (token) headers.set('X-CSRF-TOKEN', token)

            const customCorporation = document.getElementById('__custom_route_data')?.getAttribute('data-corpId')
            if (customCorporation) headers.set('X-CORP-CONTEXT', customCorporation)

            return headers
        },
        credentials: process.env.ENV === 'local' ? 'include' : 'same-origin',
    }),
    tagTypes: ['Payslips'],
    endpoints: (builder) => ({
        getPayslips: builder.query<Payslip[], void>({
            query: () => '/employee/payslip',
            transformResponse: (response: PayslipsResponse) => response.data.payslips,
        }),
    }),
})

export const {
    useGetPayslipsQuery,
} = payslipsApi